export const sleep = async (ms: number) => {
  await new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(true);
    }, ms);
  });
  await Promise.resolve(1);
};
